<script>
import Layout from "@/router/layouts/store";
import { api } from "@/state/services";
import Product from "@/components/widgets/loading-product";
import Buy from "@/components/widgets/store-buy";

export default {
  locales: {
    pt: {
      Products: "Produtos",
      'We do not yet have any products available in this category.': 'Ainda não temos nenhum produto disponível nesta categoria.',
      'from': 'de',
      'for': 'por',
      'Binary': 'Binário',
      'Unilevel': 'Unilevel',
      'Graduation': 'Graduação',
      'Premiation': 'Premiação',
      'UNAVAILABLE': 'INDISPONÍVEL',
    },
    es: {
      Products: "Productos",
      'We do not yet have any products available in this category.': 'Aún no tenemos ningún producto disponible en esta categoría.',
      'from': 'de',
      'for': 'por',
      'Binary': 'Binario',
      'Unilevel': 'Unilevel',
      'Graduation': 'Graduación',
      'Premiation': 'Premiación',
      'UNAVAILABLE': 'NO DISPONIBLE',
    },
  },
  components: {
    Layout,
    Product,
    Buy,
  },
  data() {
    return {
      product: {
        modal: false,

        id: null,
        images: [],
        name: null,
        description: null,
        variations: null,
      },

      products: {
        loading: true,
        errored: false,
        empty: false,
        list: null,
      },
    };
  },
  methods: {
    getProducts() {
      api
        .get("store/featured")
        .then((response) => {
          if (response.data.status == "success") {
            this.products.list = response.data.list;
            this.products.loading = false;
          }
        })
        .catch((error) => {
          this.products.errored = error;
          this.products.loading = false;
        })
        .finally(() => {
          this.products.loading = false;
        });
    },
    showProduct(product) {
      this.product.modal = true;
      this.product.id = product.id;
      this.product.variations = product.variations;
      this.product.images = product.images;
      this.product.name = product.name;
      this.product.description = product.description;
    },
  },
  mounted() {
    this.getProducts();
  },
};
</script>

<template>
  <Layout ref="store">
    <div v-if="products.loading" class="row">
      <div class="col-md-6 col-lg-4">
        <div class="card card-h-fix">
          <div class="card-body text-center">
            <Product></Product>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-4">
        <div class="card card-h-fix">
          <div class="card-body text-center">
            <Product></Product>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="!products.list || (products.list && products.list.length == 0)" class="card">
      <div class="card-body">
        <div class="text-center py-5">
          <i class="far fa-sad-cry font-size-24"></i><br />
          {{ t('We do not yet have any products available in this category.') }}
        </div>
      </div>
    </div>
    <div v-else class="row">
      <div class="col-md-4" v-for="(product, id) in products.list" :key="id">
        <div v-if="product.instock == 'yes'">
          <div class="card card-h-fix">
            <div class="card-body text-center">
              <div class="mb-3">
                <b-carousel style="margin: 0 auto; max-width: 350px" controls indicators fade :interval="0">
                  <b-carousel-slide style="max-width: 350px; min-height: 200px" v-for="(image, i) in product.images" :key="i" :img-src="image"></b-carousel-slide>
                </b-carousel>
              </div>
              <div class="font-weight-medium text-dark">
                {{ product.name }}
                <button class="btn btn-link p-0 text-dark" @click="showProduct(product)">
                  <i class="bx bx-info-circle font-size-22"></i>
                </button>
              </div>
              <div class="text-center mt-3">
                <h5 class="mb-0 font-size-14 text-muted">
                  {{ t('from') }} {{ product.price.consumer | currency }}
                </h5>
                <h5 class="mb-0 font-size-16">
                  {{ t('for') }} {{ product.price.affiliate | currency }}
                </h5>
              </div>
              <Buy :id="product.id" :variations="product.variations" class="mt-3"></Buy>
              <div class="mt-3 d-flex justify-content-center text-uppercase">
                <div class="mx-1" style="line-height: 15px" v-if="product.points.graduation > 0">
                  <span class="align-self-center font-size-13 bg-soft-light rounded px-2">{{ product.points.graduation }}</span><br />
                  <span class="align-self-center font-size-11">{{ t('PG') }}</span>
                </div>
                <div class="mx-1" style="line-height: 15px" v-if="product.points.binary > 0">
                  <span class="align-self-center font-size-13 bg-soft-light rounded px-2">{{ product.points.binary }}</span><br />
                  <span class="align-self-center font-size-11">{{ t('PV') }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="card card-h-fix">
            <div class="card-body text-center">
              <div class="mb-3">
                <b-carousel style="margin: 0 auto; max-width: 350px" controls indicators fade :interval="0">
                  <b-carousel-slide style="
                      max-width: 350px;
                      min-height: 200px;
                      filter: grayscale(100%);
                    " v-for="(image, i) in product.images" :key="i" :img-src="image"></b-carousel-slide>
                </b-carousel>
              </div>
              <div class="font-weight-medium text-dark">
                {{ product.name }}
                <button class="btn btn-link p-0 text-dark" @click="showProduct(product)">
                  <i class="bx bx-info-circle font-size-22"></i>
                </button>
              </div>
              <div class="text-center mt-3">
                <h5 class="mb-0 font-size-14 text-muted">
                  {{ t('from') }} {{ product.price.consumer | currency }}
                </h5>
                <h5 class="mb-0 font-size-16">
                  {{ t('for') }} {{ product.price.affiliate | currency }}
                </h5>
              </div>
              <b-button disabled block class="mt-3">{{ t('UNAVAILABLE') }}</b-button>
              <div class="mt-3 d-flex justify-content-center text-uppercase">
                <div class="mx-1" style="line-height: 15px" v-if="product.points.graduation > 0">
                  <span class="align-self-center font-size-13 bg-soft-light rounded px-2">{{ product.points.graduation }}</span><br />
                  <span class="align-self-center font-size-11">{{ t('PG') }}</span>
                </div>
                <div class="mx-1" style="line-height: 15px" v-if="product.points.binary > 0">
                  <span class="align-self-center font-size-13 bg-soft-light rounded px-2">{{ product.points.binary }}</span><br />
                  <span class="align-self-center font-size-11">{{ t('PV') }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal v-model="product.modal" hide-footer centered>
      <div class="mb-3">
        <b-carousel style="margin: 0 auto; max-width: 350px" controls indicators fade :interval="0">
          <b-carousel-slide style="max-width: 350px; min-height: 200px" v-for="(image, i) in product.images" :key="i" :img-src="image"></b-carousel-slide>
        </b-carousel>
      </div>
      <h4 class="font-weight-medium mb-3">{{ product.name }}</h4>
      <div v-html="product.description"></div>
    </b-modal>
  </Layout>
</template>